import { KSTADIUM_ACCESS_TOKEN_KEY } from '../services/kstadium.service';
import { getAccessToken } from '../storage/token';

interface HexlantResponse {
  resultCode: 'success' | 'failed';
  resultMessage: string;
  totalCount: number;
  data: {
    transactionHash: string;
  };
}
export interface HexlantBalance {
  resultCode: 'success' | 'failed';
  resultMessage: string;
  totalCount: number;
  data: {
    coins: {
      tokenSymbol: 'ksETH' | 'ksKOK' | 'KSTA' | 'ksUSDT';
      balance: string;
    }[];
  };
}
export interface HexlantBalanceDev {
  resultCode: 'success' | 'failed';
  resultMessage: string;
  totalCount: number;
  data: {
    coins: {
      tokenSymbol: 'ksETH_dev' | 'ksKOK_dev' | 'KSTA_dev' | 'ksUSDT_dev';
      balance: string;
    }[];
  };
}

// TODO: 리팩토링시 type 상속으로 중복 제거할 것
interface HexlantAllownaceRes {
  resultCode: 'success' | 'failed';
  resultMessage: string;
  totalCount: number;
  data: {
    allowanceValue: string;
  };
}

const HEXLANT = {
  async hexlantWithdraw(
    htlcContractAddress: string,
    hashlock: string,
    fromPreImage: string,
  ): Promise<HexlantResponse> {
    const res = await fetch(
      `${process.env.REACT_APP_KSTADIUM_BACKEND_URL}/kstadium/api/comm/bridge/withdraw`,
      {
        method: `POST`,
        headers: {
          'Content-Type': `application/json`,
          'X-AUTH-TOKEN': `${localStorage.getItem(KSTADIUM_ACCESS_TOKEN_KEY)}`,
        },
        body: JSON.stringify({
          hashlock,
          htlcContractAddress,
          preImage: fromPreImage,
        }),
      },
    );

    if (res.ok) {
      const result: HexlantResponse = await res.json();

      return result;
    }
    throw new Error(`Request error : ${res.status}`);
  },

  async hexlantNewContract(
    amount: string,
    chainId: string,
    hashlock: string,
    receiver: string,
    timelock: string,
    htlcContractAddress: string,
  ): Promise<HexlantResponse> {
    const res = await fetch(
      `${process.env.REACT_APP_KSTADIUM_BACKEND_URL}/kstadium/api/comm/bridge/newContract`,
      {
        method: `POST`,
        headers: {
          'Content-Type': `application/json`,
          'X-AUTH-TOKEN': getAccessToken(`disposable`) || ``,
        },
        body: JSON.stringify({
          amount,
          chainId,
          hashlock,
          htlcContractAddress,
          receiver,
          timelock,
        }),
      },
    );

    if (res.ok) {
      const result: HexlantResponse = await res.json();

      return result;
    }
    throw new Error(`Request error : ${res.status}`);
  },

  async hexlantNewContractToken(
    amount: string,
    chainId: string,
    hashlock: string,
    receiver: string,
    timelock: string,
    htlcTokenContractAddress: string,
    tokenContractAddress: string,
  ): Promise<HexlantResponse> {
    const res = await fetch(
      `${process.env.REACT_APP_KSTADIUM_BACKEND_URL}/kstadium/api/comm/bridge/newContract/token`,
      {
        method: `POST`,
        headers: {
          'Content-Type': `application/json`,
          'X-AUTH-TOKEN': getAccessToken(`disposable`) || ``,
        },
        body: JSON.stringify({
          amount,
          chainId,
          hashlock,
          htlcTokenContractAddress,
          receiver,
          timelock,
          tokenContractAddress,
        }),
      },
    );

    if (res.ok) {
      const result: HexlantResponse = await res.json();

      return result;
    }
    throw new Error(`Request error : ${res.status}`);
  },

  async hexlantRefund(
    hashlock: string,
    htlcContractAddress: string,
  ): Promise<HexlantResponse> {
    const res = await fetch(
      `${process.env.REACT_APP_KSTADIUM_BACKEND_URL}/kstadium/api/comm/bridge/refund`,
      {
        method: `POST`,
        headers: {
          'Content-Type': `application/json`,
          'X-AUTH-TOKEN': `${localStorage.getItem(KSTADIUM_ACCESS_TOKEN_KEY)}`,
        },
        body: JSON.stringify({
          hashlock,
          htlcContractAddress,
        }),
      },
    );

    if (res.ok) {
      const result: HexlantResponse = await res.json();

      return result;
    }
    throw new Error(`Request error : ${res.status}`);
  },

  async hexlantBalance(): Promise<HexlantBalance> {
    const res = await fetch(
      `${process.env.REACT_APP_KSTADIUM_BACKEND_URL}/kstadium/api/comm/octet/v2/my/balance`,
      {
        method: `GET`,
        headers: {
          'Content-Type': `application/json`,
          'X-AUTH-TOKEN': `${localStorage.getItem(KSTADIUM_ACCESS_TOKEN_KEY)}`,
        },
      },
    );

    if (res.ok) {
      const result: HexlantBalance = await res.json();

      return result;
    }
    throw new Error(`Request error : ${res.status}`);
  },
  async hexlantBalanceDev(): Promise<HexlantBalanceDev> {
    const res = await fetch(
      `${process.env.REACT_APP_KSTADIUM_BACKEND_URL}/kstadium/api/comm/octet/v2/my/balance`,
      {
        method: `GET`,
        headers: {
          'Content-Type': `application/json`,
          'X-AUTH-TOKEN': `${localStorage.getItem(KSTADIUM_ACCESS_TOKEN_KEY)}`,
        },
      },
    );

    if (res.ok) {
      const result: HexlantBalanceDev = await res.json();

      return result;
    }
    throw new Error(`Request error : ${res.status}`);
  },

  async hexlantAllowance(
    contract: string,
    spender: string,
  ): Promise<HexlantAllownaceRes> {
    const res = await fetch(
      `${process.env.REACT_APP_KSTADIUM_BACKEND_URL}/kstadium/api/comm/bridge/allowance`,
      {
        method: `POST`,
        headers: {
          'Content-Type': `application/json`,
          'X-AUTH-TOKEN': `${localStorage.getItem(KSTADIUM_ACCESS_TOKEN_KEY)}`,
        },
        body: JSON.stringify({
          contract,
          spender,
        }),
      },
    );

    if (res.ok) {
      const result: HexlantAllownaceRes = await res.json();

      return result;
    }
    throw new Error(`Request error : ${res.status}`);
  },

  async hexlantApprove(
    amount: string,
    contract: string,
    spender: string,
  ): Promise<HexlantResponse> {
    const res = await fetch(
      `${process.env.REACT_APP_KSTADIUM_BACKEND_URL}/kstadium/api/comm/bridge/approve`,
      {
        method: `POST`,
        headers: {
          'Content-Type': `application/json`,
          'X-AUTH-TOKEN': `${localStorage.getItem(KSTADIUM_ACCESS_TOKEN_KEY)}`,
        },
        body: JSON.stringify({
          amount,
          contract,
          spender,
        }),
      },
    );

    if (res.ok) {
      const result: HexlantResponse = await res.json();

      return result;
    }
    throw new Error(`Request error : ${res.status}`);
  },
};

export default HEXLANT;
